module.exports = __webpack_public_path__ + "img/verkeersteken.a55dcec1.png";